/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * OSI.Core
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiResponse,
  ApiResponseBooleanSystemPrivateCoreLib,
  ApiResponseDbAbonentOSICoreTypes,
  ApiResponseDbOsiDocOSICoreTypes,
  ApiResponseDbOsiOSICoreTypes,
  ApiResponseDbPlanAccuralOSICoreTypes,
  ApiResponseIEnumerable1OSICoreModelsDbAbonentPrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsDbActPrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsDbOsiAccountApplicationPrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsDbOsiAccountPrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsDbOsiDocPrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsDbOsiPrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsDbOsiServiceCompanyPrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsDbOsiServicePrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsDbPlanAccuralPrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsResponsesPastDebtsByOsiResponsePrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsResponsesServiceGroupResponsePrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsResponsesServiceGroupSaldoResponsePrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsResponsesTrustedUserResponsePrivateCoreLib,
  ApiResponseList1OSICoreModelsDbAbonentPrivateCoreLib,
  ApiResponseObjectSystemPrivateCoreLib,
  DeleteApiOsiIdTrustedUserParams,
  GetApiOsiIdAbonentsParams,
  PostApiOsiIdTrustedUserParams,
  RequestsAddScanDoc,
  RequestsOsiRequest,
  RequestsTrustedUserRequest
} from '../models';

import { axiosForReactQueryInstance } from '../../reactQuery';
import type { ErrorType, BodyType } from '../../reactQuery';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Получить список всех ОСИ
 */
export const getApiOsiAll = (options?: SecondParameter<typeof axiosForReactQueryInstance>, signal?: AbortSignal) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsDbOsiPrivateCoreLib>(
    { url: `/api/Osi/all`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiAllQueryKey = () => {
  return [`/api/Osi/all`] as const;
};

export const getGetApiOsiAllQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiAll>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiAll>>, TError, TData>>;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiAllQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiAll>>> = ({ signal }) =>
    getApiOsiAll(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiAllQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOsiAll>>>;
export type GetApiOsiAllQueryError = ErrorType<unknown>;

export function useGetApiOsiAll<TData = Awaited<ReturnType<typeof getApiOsiAll>>, TError = ErrorType<unknown>>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiAll>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiAll>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiAll>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiAll<TData = Awaited<ReturnType<typeof getApiOsiAll>>, TError = ErrorType<unknown>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiAll>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiAll>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiAll>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiAll<TData = Awaited<ReturnType<typeof getApiOsiAll>>, TError = ErrorType<unknown>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiAll>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить список всех ОСИ
 */

export function useGetApiOsiAll<TData = Awaited<ReturnType<typeof getApiOsiAll>>, TError = ErrorType<unknown>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiAll>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiAllQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить список всех активных ОСИ
 */
export const getApiOsiAllActive = (
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsDbOsiPrivateCoreLib>(
    { url: `/api/Osi/all-active`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiAllActiveQueryKey = () => {
  return [`/api/Osi/all-active`] as const;
};

export const getGetApiOsiAllActiveQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiAllActive>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiAllActive>>, TError, TData>>;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiAllActiveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiAllActive>>> = ({ signal }) =>
    getApiOsiAllActive(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiAllActive>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiAllActiveQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOsiAllActive>>>;
export type GetApiOsiAllActiveQueryError = ErrorType<unknown>;

export function useGetApiOsiAllActive<
  TData = Awaited<ReturnType<typeof getApiOsiAllActive>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiAllActive>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiAllActive>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiAllActive>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiAllActive<
  TData = Awaited<ReturnType<typeof getApiOsiAllActive>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiAllActive>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiAllActive>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiAllActive>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiAllActive<
  TData = Awaited<ReturnType<typeof getApiOsiAllActive>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiAllActive>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить список всех активных ОСИ
 */

export function useGetApiOsiAllActive<
  TData = Awaited<ReturnType<typeof getApiOsiAllActive>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiAllActive>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiAllActiveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить данные по ОСИ
 */
export const getApiOsiId = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseDbOsiOSICoreTypes>(
    { url: `/api/Osi/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiIdQueryKey = (id: number) => {
  return [`/api/Osi/${id}`] as const;
};

export const getGetApiOsiIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiId>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiId>>> = ({ signal }) =>
    getApiOsiId(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOsiId>>>;
export type GetApiOsiIdQueryError = ErrorType<unknown>;

export function useGetApiOsiId<TData = Awaited<ReturnType<typeof getApiOsiId>>, TError = ErrorType<unknown>>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiId>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiId<TData = Awaited<ReturnType<typeof getApiOsiId>>, TError = ErrorType<unknown>>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiId>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiId<TData = Awaited<ReturnType<typeof getApiOsiId>>, TError = ErrorType<unknown>>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить данные по ОСИ
 */

export function useGetApiOsiId<TData = Awaited<ReturnType<typeof getApiOsiId>>, TError = ErrorType<unknown>>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Изменение ОСИ
 */
export const putApiOsiId = (
  id: number,
  requestsOsiRequest: BodyType<RequestsOsiRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    { url: `/api/Osi/${id}`, method: 'PUT', headers: { 'Content-Type': 'application/json' }, data: requestsOsiRequest },
    options
  );
};

export const getPutApiOsiIdMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiOsiId>>,
    TError,
    { id: number; data: BodyType<RequestsOsiRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiOsiId>>,
  TError,
  { id: number; data: BodyType<RequestsOsiRequest> },
  TContext
> => {
  const mutationKey = ['putApiOsiId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiOsiId>>,
    { id: number; data: BodyType<RequestsOsiRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiOsiId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiOsiIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiOsiId>>>;
export type PutApiOsiIdMutationBody = BodyType<RequestsOsiRequest>;
export type PutApiOsiIdMutationError = ErrorType<unknown>;

/**
 * @summary Изменение ОСИ
 */
export const usePutApiOsiId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiOsiId>>,
      TError,
      { id: number; data: BodyType<RequestsOsiRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiOsiId>>,
  TError,
  { id: number; data: BodyType<RequestsOsiRequest> },
  TContext
> => {
  const mutationOptions = getPutApiOsiIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Проверка всех данных и запуск ОСИ в работу (для председателя)
 */
export const putApiOsiIdStart = (id: number, options?: SecondParameter<typeof axiosForReactQueryInstance>) => {
  return axiosForReactQueryInstance<ApiResponse>({ url: `/api/Osi/${id}/start`, method: 'PUT' }, options);
};

export const getPutApiOsiIdStartMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putApiOsiIdStart>>, TError, { id: number }, TContext>;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof putApiOsiIdStart>>, TError, { id: number }, TContext> => {
  const mutationKey = ['putApiOsiIdStart'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiOsiIdStart>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return putApiOsiIdStart(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiOsiIdStartMutationResult = NonNullable<Awaited<ReturnType<typeof putApiOsiIdStart>>>;

export type PutApiOsiIdStartMutationError = ErrorType<unknown>;

/**
 * @summary Проверка всех данных и запуск ОСИ в работу (для председателя)
 */
export const usePutApiOsiIdStart = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof putApiOsiIdStart>>, TError, { id: number }, TContext>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof putApiOsiIdStart>>, TError, { id: number }, TContext> => {
  const mutationOptions = getPutApiOsiIdStartMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Остановка деятельности объекта ОСИ (для председателя)
 */
export const putApiOsiIdStop = (id: number, options?: SecondParameter<typeof axiosForReactQueryInstance>) => {
  return axiosForReactQueryInstance<ApiResponse>({ url: `/api/Osi/${id}/stop`, method: 'PUT' }, options);
};

export const getPutApiOsiIdStopMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putApiOsiIdStop>>, TError, { id: number }, TContext>;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof putApiOsiIdStop>>, TError, { id: number }, TContext> => {
  const mutationKey = ['putApiOsiIdStop'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiOsiIdStop>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return putApiOsiIdStop(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiOsiIdStopMutationResult = NonNullable<Awaited<ReturnType<typeof putApiOsiIdStop>>>;

export type PutApiOsiIdStopMutationError = ErrorType<unknown>;

/**
 * @summary Остановка деятельности объекта ОСИ (для председателя)
 */
export const usePutApiOsiIdStop = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof putApiOsiIdStop>>, TError, { id: number }, TContext>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof putApiOsiIdStop>>, TError, { id: number }, TContext> => {
  const mutationOptions = getPutApiOsiIdStopMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Активация объекта ОСИ, чтобы председатель увидел его у себя
 */
export const putApiOsiIdActivate = (id: number, options?: SecondParameter<typeof axiosForReactQueryInstance>) => {
  return axiosForReactQueryInstance<ApiResponse>({ url: `/api/Osi/${id}/activate`, method: 'PUT' }, options);
};

export const getPutApiOsiIdActivateMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putApiOsiIdActivate>>, TError, { id: number }, TContext>;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof putApiOsiIdActivate>>, TError, { id: number }, TContext> => {
  const mutationKey = ['putApiOsiIdActivate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiOsiIdActivate>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return putApiOsiIdActivate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiOsiIdActivateMutationResult = NonNullable<Awaited<ReturnType<typeof putApiOsiIdActivate>>>;

export type PutApiOsiIdActivateMutationError = ErrorType<unknown>;

/**
 * @summary Активация объекта ОСИ, чтобы председатель увидел его у себя
 */
export const usePutApiOsiIdActivate = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof putApiOsiIdActivate>>, TError, { id: number }, TContext>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof putApiOsiIdActivate>>, TError, { id: number }, TContext> => {
  const mutationOptions = getPutApiOsiIdActivateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Деактивация объекта ОСИ, чтобы председатель не увидел его у себя
 */
export const putApiOsiIdDeactivate = (id: number, options?: SecondParameter<typeof axiosForReactQueryInstance>) => {
  return axiosForReactQueryInstance<ApiResponse>({ url: `/api/Osi/${id}/deactivate`, method: 'PUT' }, options);
};

export const getPutApiOsiIdDeactivateMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putApiOsiIdDeactivate>>, TError, { id: number }, TContext>;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof putApiOsiIdDeactivate>>, TError, { id: number }, TContext> => {
  const mutationKey = ['putApiOsiIdDeactivate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiOsiIdDeactivate>>, { id: number }> = (props) => {
    const { id } = props ?? {};

    return putApiOsiIdDeactivate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiOsiIdDeactivateMutationResult = NonNullable<Awaited<ReturnType<typeof putApiOsiIdDeactivate>>>;

export type PutApiOsiIdDeactivateMutationError = ErrorType<unknown>;

/**
 * @summary Деактивация объекта ОСИ, чтобы председатель не увидел его у себя
 */
export const usePutApiOsiIdDeactivate = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof putApiOsiIdDeactivate>>, TError, { id: number }, TContext>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof putApiOsiIdDeactivate>>, TError, { id: number }, TContext> => {
  const mutationOptions = getPutApiOsiIdDeactivateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Добавление сканированного документа к ОСИ
 */
export const postApiOsiIdDocs = (
  id: number,
  requestsAddScanDoc: BodyType<RequestsAddScanDoc>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseDbOsiDocOSICoreTypes>(
    {
      url: `/api/Osi/${id}/docs`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestsAddScanDoc,
      signal
    },
    options
  );
};

export const getPostApiOsiIdDocsMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiOsiIdDocs>>,
    TError,
    { id: number; data: BodyType<RequestsAddScanDoc> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiOsiIdDocs>>,
  TError,
  { id: number; data: BodyType<RequestsAddScanDoc> },
  TContext
> => {
  const mutationKey = ['postApiOsiIdDocs'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiOsiIdDocs>>,
    { id: number; data: BodyType<RequestsAddScanDoc> }
  > = (props) => {
    const { id, data } = props ?? {};

    return postApiOsiIdDocs(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiOsiIdDocsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiOsiIdDocs>>>;
export type PostApiOsiIdDocsMutationBody = BodyType<RequestsAddScanDoc>;
export type PostApiOsiIdDocsMutationError = ErrorType<unknown>;

/**
 * @summary Добавление сканированного документа к ОСИ
 */
export const usePostApiOsiIdDocs = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiOsiIdDocs>>,
      TError,
      { id: number; data: BodyType<RequestsAddScanDoc> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiOsiIdDocs>>,
  TError,
  { id: number; data: BodyType<RequestsAddScanDoc> },
  TContext
> => {
  const mutationOptions = getPostApiOsiIdDocsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Получить сканированные документы по ОСИ
 */
export const getApiOsiIdDocs = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsDbOsiDocPrivateCoreLib>(
    { url: `/api/Osi/${id}/docs`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiIdDocsQueryKey = (id: number) => {
  return [`/api/Osi/${id}/docs`] as const;
};

export const getGetApiOsiIdDocsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiIdDocs>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdDocs>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiIdDocsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiIdDocs>>> = ({ signal }) =>
    getApiOsiIdDocs(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiIdDocs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiIdDocsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOsiIdDocs>>>;
export type GetApiOsiIdDocsQueryError = ErrorType<unknown>;

export function useGetApiOsiIdDocs<TData = Awaited<ReturnType<typeof getApiOsiIdDocs>>, TError = ErrorType<unknown>>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdDocs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdDocs>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdDocs>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdDocs<TData = Awaited<ReturnType<typeof getApiOsiIdDocs>>, TError = ErrorType<unknown>>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdDocs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdDocs>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdDocs>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdDocs<TData = Awaited<ReturnType<typeof getApiOsiIdDocs>>, TError = ErrorType<unknown>>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdDocs>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить сканированные документы по ОСИ
 */

export function useGetApiOsiIdDocs<TData = Awaited<ReturnType<typeof getApiOsiIdDocs>>, TError = ErrorType<unknown>>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdDocs>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiIdDocsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Удалить сканированный документ у ОСИ
 */
export const deleteApiOsiIdDocsDocId = (
  id: number,
  docId: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>({ url: `/api/Osi/${id}/docs/${docId}`, method: 'DELETE' }, options);
};

export const getDeleteApiOsiIdDocsDocIdMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiOsiIdDocsDocId>>,
    TError,
    { id: number; docId: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiOsiIdDocsDocId>>,
  TError,
  { id: number; docId: number },
  TContext
> => {
  const mutationKey = ['deleteApiOsiIdDocsDocId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiOsiIdDocsDocId>>,
    { id: number; docId: number }
  > = (props) => {
    const { id, docId } = props ?? {};

    return deleteApiOsiIdDocsDocId(id, docId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiOsiIdDocsDocIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiOsiIdDocsDocId>>>;

export type DeleteApiOsiIdDocsDocIdMutationError = ErrorType<unknown>;

/**
 * @summary Удалить сканированный документ у ОСИ
 */
export const useDeleteApiOsiIdDocsDocId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiOsiIdDocsDocId>>,
      TError,
      { id: number; docId: number },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiOsiIdDocsDocId>>,
  TError,
  { id: number; docId: number },
  TContext
> => {
  const mutationOptions = getDeleteApiOsiIdDocsDocIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Абоненты данного ОСИ
 */
export const getApiOsiIdAbonents = (
  id: number,
  params?: GetApiOsiIdAbonentsParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsDbAbonentPrivateCoreLib>(
    { url: `/api/Osi/${id}/abonents`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiOsiIdAbonentsQueryKey = (id: number, params?: GetApiOsiIdAbonentsParams) => {
  return [`/api/Osi/${id}/abonents`, ...(params ? [params] : [])] as const;
};

export const getGetApiOsiIdAbonentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiIdAbonents>>,
  TError = ErrorType<unknown>
>(
  id: number,
  params?: GetApiOsiIdAbonentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAbonents>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiIdAbonentsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiIdAbonents>>> = ({ signal }) =>
    getApiOsiIdAbonents(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiIdAbonents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiIdAbonentsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOsiIdAbonents>>>;
export type GetApiOsiIdAbonentsQueryError = ErrorType<unknown>;

export function useGetApiOsiIdAbonents<
  TData = Awaited<ReturnType<typeof getApiOsiIdAbonents>>,
  TError = ErrorType<unknown>
>(
  id: number,
  params: undefined | GetApiOsiIdAbonentsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAbonents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdAbonents>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdAbonents>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdAbonents<
  TData = Awaited<ReturnType<typeof getApiOsiIdAbonents>>,
  TError = ErrorType<unknown>
>(
  id: number,
  params?: GetApiOsiIdAbonentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAbonents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdAbonents>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdAbonents>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdAbonents<
  TData = Awaited<ReturnType<typeof getApiOsiIdAbonents>>,
  TError = ErrorType<unknown>
>(
  id: number,
  params?: GetApiOsiIdAbonentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAbonents>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Абоненты данного ОСИ
 */

export function useGetApiOsiIdAbonents<
  TData = Awaited<ReturnType<typeof getApiOsiIdAbonents>>,
  TError = ErrorType<unknown>
>(
  id: number,
  params?: GetApiOsiIdAbonentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAbonents>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiIdAbonentsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить абонента данного ОСИ по номеру помещения
 */
export const getApiOsiIdAbonentsFlat = (
  id: number,
  flat: string,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseDbAbonentOSICoreTypes>(
    { url: `/api/Osi/${id}/abonents/${flat}`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiIdAbonentsFlatQueryKey = (id: number, flat: string) => {
  return [`/api/Osi/${id}/abonents/${flat}`] as const;
};

export const getGetApiOsiIdAbonentsFlatQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiIdAbonentsFlat>>,
  TError = ErrorType<unknown>
>(
  id: number,
  flat: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAbonentsFlat>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiIdAbonentsFlatQueryKey(id, flat);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiIdAbonentsFlat>>> = ({ signal }) =>
    getApiOsiIdAbonentsFlat(id, flat, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(id && flat), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiIdAbonentsFlat>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiIdAbonentsFlatQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOsiIdAbonentsFlat>>>;
export type GetApiOsiIdAbonentsFlatQueryError = ErrorType<unknown>;

export function useGetApiOsiIdAbonentsFlat<
  TData = Awaited<ReturnType<typeof getApiOsiIdAbonentsFlat>>,
  TError = ErrorType<unknown>
>(
  id: number,
  flat: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAbonentsFlat>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdAbonentsFlat>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdAbonentsFlat>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdAbonentsFlat<
  TData = Awaited<ReturnType<typeof getApiOsiIdAbonentsFlat>>,
  TError = ErrorType<unknown>
>(
  id: number,
  flat: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAbonentsFlat>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdAbonentsFlat>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdAbonentsFlat>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdAbonentsFlat<
  TData = Awaited<ReturnType<typeof getApiOsiIdAbonentsFlat>>,
  TError = ErrorType<unknown>
>(
  id: number,
  flat: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAbonentsFlat>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить абонента данного ОСИ по номеру помещения
 */

export function useGetApiOsiIdAbonentsFlat<
  TData = Awaited<ReturnType<typeof getApiOsiIdAbonentsFlat>>,
  TError = ErrorType<unknown>
>(
  id: number,
  flat: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAbonentsFlat>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiIdAbonentsFlatQueryOptions(id, flat, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Счета данного ОСИ
 */
export const getApiOsiIdAccounts = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsDbOsiAccountPrivateCoreLib>(
    { url: `/api/Osi/${id}/accounts`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiIdAccountsQueryKey = (id: number) => {
  return [`/api/Osi/${id}/accounts`] as const;
};

export const getGetApiOsiIdAccountsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiIdAccounts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAccounts>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiIdAccountsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiIdAccounts>>> = ({ signal }) =>
    getApiOsiIdAccounts(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiIdAccounts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiIdAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOsiIdAccounts>>>;
export type GetApiOsiIdAccountsQueryError = ErrorType<unknown>;

export function useGetApiOsiIdAccounts<
  TData = Awaited<ReturnType<typeof getApiOsiIdAccounts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAccounts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdAccounts>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdAccounts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdAccounts<
  TData = Awaited<ReturnType<typeof getApiOsiIdAccounts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAccounts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdAccounts>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdAccounts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdAccounts<
  TData = Awaited<ReturnType<typeof getApiOsiIdAccounts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAccounts>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Счета данного ОСИ
 */

export function useGetApiOsiIdAccounts<
  TData = Awaited<ReturnType<typeof getApiOsiIdAccounts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAccounts>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiIdAccountsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Счета данного ОСИ
 */
export const getApiOsiIdAccountApplications = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsDbOsiAccountApplicationPrivateCoreLib>(
    { url: `/api/Osi/${id}/account-applications`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiIdAccountApplicationsQueryKey = (id: number) => {
  return [`/api/Osi/${id}/account-applications`] as const;
};

export const getGetApiOsiIdAccountApplicationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiIdAccountApplications>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAccountApplications>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiIdAccountApplicationsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiIdAccountApplications>>> = ({ signal }) =>
    getApiOsiIdAccountApplications(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiIdAccountApplications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiIdAccountApplicationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiOsiIdAccountApplications>>
>;
export type GetApiOsiIdAccountApplicationsQueryError = ErrorType<unknown>;

export function useGetApiOsiIdAccountApplications<
  TData = Awaited<ReturnType<typeof getApiOsiIdAccountApplications>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAccountApplications>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdAccountApplications>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdAccountApplications>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdAccountApplications<
  TData = Awaited<ReturnType<typeof getApiOsiIdAccountApplications>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAccountApplications>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdAccountApplications>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdAccountApplications>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdAccountApplications<
  TData = Awaited<ReturnType<typeof getApiOsiIdAccountApplications>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAccountApplications>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Счета данного ОСИ
 */

export function useGetApiOsiIdAccountApplications<
  TData = Awaited<ReturnType<typeof getApiOsiIdAccountApplications>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAccountApplications>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiIdAccountApplicationsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Планы начислений данного ОСИ
 */
export const getApiOsiIdPlanAccurals = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsDbPlanAccuralPrivateCoreLib>(
    { url: `/api/Osi/${id}/plan-accurals`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiIdPlanAccuralsQueryKey = (id: number) => {
  return [`/api/Osi/${id}/plan-accurals`] as const;
};

export const getGetApiOsiIdPlanAccuralsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiIdPlanAccurals>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdPlanAccurals>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiIdPlanAccuralsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiIdPlanAccurals>>> = ({ signal }) =>
    getApiOsiIdPlanAccurals(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiIdPlanAccurals>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiIdPlanAccuralsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOsiIdPlanAccurals>>>;
export type GetApiOsiIdPlanAccuralsQueryError = ErrorType<unknown>;

export function useGetApiOsiIdPlanAccurals<
  TData = Awaited<ReturnType<typeof getApiOsiIdPlanAccurals>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdPlanAccurals>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdPlanAccurals>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdPlanAccurals>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdPlanAccurals<
  TData = Awaited<ReturnType<typeof getApiOsiIdPlanAccurals>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdPlanAccurals>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdPlanAccurals>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdPlanAccurals>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdPlanAccurals<
  TData = Awaited<ReturnType<typeof getApiOsiIdPlanAccurals>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdPlanAccurals>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Планы начислений данного ОСИ
 */

export function useGetApiOsiIdPlanAccurals<
  TData = Awaited<ReturnType<typeof getApiOsiIdPlanAccurals>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdPlanAccurals>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiIdPlanAccuralsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить последний план начислений или создать новый
 */
export const getApiOsiIdGetLastPlanOrCreateNew = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseDbPlanAccuralOSICoreTypes>(
    { url: `/api/Osi/${id}/get-last-plan-or-create-new`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiIdGetLastPlanOrCreateNewQueryKey = (id: number) => {
  return [`/api/Osi/${id}/get-last-plan-or-create-new`] as const;
};

export const getGetApiOsiIdGetLastPlanOrCreateNewQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiIdGetLastPlanOrCreateNew>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdGetLastPlanOrCreateNew>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiIdGetLastPlanOrCreateNewQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiIdGetLastPlanOrCreateNew>>> = ({ signal }) =>
    getApiOsiIdGetLastPlanOrCreateNew(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiIdGetLastPlanOrCreateNew>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiIdGetLastPlanOrCreateNewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiOsiIdGetLastPlanOrCreateNew>>
>;
export type GetApiOsiIdGetLastPlanOrCreateNewQueryError = ErrorType<unknown>;

export function useGetApiOsiIdGetLastPlanOrCreateNew<
  TData = Awaited<ReturnType<typeof getApiOsiIdGetLastPlanOrCreateNew>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdGetLastPlanOrCreateNew>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdGetLastPlanOrCreateNew>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdGetLastPlanOrCreateNew>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdGetLastPlanOrCreateNew<
  TData = Awaited<ReturnType<typeof getApiOsiIdGetLastPlanOrCreateNew>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdGetLastPlanOrCreateNew>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdGetLastPlanOrCreateNew>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdGetLastPlanOrCreateNew>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdGetLastPlanOrCreateNew<
  TData = Awaited<ReturnType<typeof getApiOsiIdGetLastPlanOrCreateNew>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdGetLastPlanOrCreateNew>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить последний план начислений или создать новый
 */

export function useGetApiOsiIdGetLastPlanOrCreateNew<
  TData = Awaited<ReturnType<typeof getApiOsiIdGetLastPlanOrCreateNew>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdGetLastPlanOrCreateNew>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiIdGetLastPlanOrCreateNewQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Список услуг данного ОСИ
 */
export const getApiOsiIdServices = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsDbOsiServicePrivateCoreLib>(
    { url: `/api/Osi/${id}/services`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiIdServicesQueryKey = (id: number) => {
  return [`/api/Osi/${id}/services`] as const;
};

export const getGetApiOsiIdServicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiIdServices>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdServices>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiIdServicesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiIdServices>>> = ({ signal }) =>
    getApiOsiIdServices(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiIdServices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiIdServicesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOsiIdServices>>>;
export type GetApiOsiIdServicesQueryError = ErrorType<unknown>;

export function useGetApiOsiIdServices<
  TData = Awaited<ReturnType<typeof getApiOsiIdServices>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdServices>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdServices>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdServices>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdServices<
  TData = Awaited<ReturnType<typeof getApiOsiIdServices>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdServices>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdServices>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdServices>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdServices<
  TData = Awaited<ReturnType<typeof getApiOsiIdServices>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdServices>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Список услуг данного ОСИ
 */

export function useGetApiOsiIdServices<
  TData = Awaited<ReturnType<typeof getApiOsiIdServices>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdServices>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiIdServicesQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Список услуг данного ОСИ с абонентами
 */
export const getApiOsiIdV2Services = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsResponsesServiceGroupResponsePrivateCoreLib>(
    { url: `/api/Osi/${id}/v2/services`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiIdV2ServicesQueryKey = (id: number) => {
  return [`/api/Osi/${id}/v2/services`] as const;
};

export const getGetApiOsiIdV2ServicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiIdV2Services>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdV2Services>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiIdV2ServicesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiIdV2Services>>> = ({ signal }) =>
    getApiOsiIdV2Services(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiIdV2Services>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiIdV2ServicesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOsiIdV2Services>>>;
export type GetApiOsiIdV2ServicesQueryError = ErrorType<unknown>;

export function useGetApiOsiIdV2Services<
  TData = Awaited<ReturnType<typeof getApiOsiIdV2Services>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdV2Services>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdV2Services>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdV2Services>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdV2Services<
  TData = Awaited<ReturnType<typeof getApiOsiIdV2Services>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdV2Services>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdV2Services>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdV2Services>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdV2Services<
  TData = Awaited<ReturnType<typeof getApiOsiIdV2Services>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdV2Services>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Список услуг данного ОСИ с абонентами
 */

export function useGetApiOsiIdV2Services<
  TData = Awaited<ReturnType<typeof getApiOsiIdV2Services>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdV2Services>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiIdV2ServicesQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Список сервисных компаний данного ОСИ
 */
export const getApiOsiIdServiceCompanies = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsDbOsiServiceCompanyPrivateCoreLib>(
    { url: `/api/Osi/${id}/service-companies`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiIdServiceCompaniesQueryKey = (id: number) => {
  return [`/api/Osi/${id}/service-companies`] as const;
};

export const getGetApiOsiIdServiceCompaniesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiIdServiceCompanies>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdServiceCompanies>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiIdServiceCompaniesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiIdServiceCompanies>>> = ({ signal }) =>
    getApiOsiIdServiceCompanies(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiIdServiceCompanies>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiIdServiceCompaniesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiOsiIdServiceCompanies>>
>;
export type GetApiOsiIdServiceCompaniesQueryError = ErrorType<unknown>;

export function useGetApiOsiIdServiceCompanies<
  TData = Awaited<ReturnType<typeof getApiOsiIdServiceCompanies>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdServiceCompanies>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdServiceCompanies>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdServiceCompanies>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdServiceCompanies<
  TData = Awaited<ReturnType<typeof getApiOsiIdServiceCompanies>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdServiceCompanies>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdServiceCompanies>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdServiceCompanies>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdServiceCompanies<
  TData = Awaited<ReturnType<typeof getApiOsiIdServiceCompanies>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdServiceCompanies>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Список сервисных компаний данного ОСИ
 */

export function useGetApiOsiIdServiceCompanies<
  TData = Awaited<ReturnType<typeof getApiOsiIdServiceCompanies>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdServiceCompanies>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiIdServiceCompaniesQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Установить шаг визарда
 */
export const putApiOsiIdWizardStep = (
  id: number,
  putApiOsiIdWizardStepBody: BodyType<string>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    {
      url: `/api/Osi/${id}/wizard-step`,
      method: 'PUT',
      headers: { 'Content-Type': 'text/plain' },
      data: putApiOsiIdWizardStepBody
    },
    options
  );
};

export const getPutApiOsiIdWizardStepMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiOsiIdWizardStep>>,
    TError,
    { id: number; data: BodyType<string> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiOsiIdWizardStep>>,
  TError,
  { id: number; data: BodyType<string> },
  TContext
> => {
  const mutationKey = ['putApiOsiIdWizardStep'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiOsiIdWizardStep>>,
    { id: number; data: BodyType<string> }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiOsiIdWizardStep(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiOsiIdWizardStepMutationResult = NonNullable<Awaited<ReturnType<typeof putApiOsiIdWizardStep>>>;
export type PutApiOsiIdWizardStepMutationBody = BodyType<string>;
export type PutApiOsiIdWizardStepMutationError = ErrorType<unknown>;

/**
 * @summary Установить шаг визарда
 */
export const usePutApiOsiIdWizardStep = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiOsiIdWizardStep>>,
      TError,
      { id: number; data: BodyType<string> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiOsiIdWizardStep>>,
  TError,
  { id: number; data: BodyType<string> },
  TContext
> => {
  const mutationOptions = getPutApiOsiIdWizardStepMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Список неподписанных актов по ОСИ
 */
export const getApiOsiIdNotSignedActs = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsDbActPrivateCoreLib>(
    { url: `/api/Osi/${id}/not-signed-acts`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiIdNotSignedActsQueryKey = (id: number) => {
  return [`/api/Osi/${id}/not-signed-acts`] as const;
};

export const getGetApiOsiIdNotSignedActsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiIdNotSignedActs>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdNotSignedActs>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiIdNotSignedActsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiIdNotSignedActs>>> = ({ signal }) =>
    getApiOsiIdNotSignedActs(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiIdNotSignedActs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiIdNotSignedActsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOsiIdNotSignedActs>>>;
export type GetApiOsiIdNotSignedActsQueryError = ErrorType<unknown>;

export function useGetApiOsiIdNotSignedActs<
  TData = Awaited<ReturnType<typeof getApiOsiIdNotSignedActs>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdNotSignedActs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdNotSignedActs>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdNotSignedActs>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdNotSignedActs<
  TData = Awaited<ReturnType<typeof getApiOsiIdNotSignedActs>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdNotSignedActs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdNotSignedActs>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdNotSignedActs>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdNotSignedActs<
  TData = Awaited<ReturnType<typeof getApiOsiIdNotSignedActs>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdNotSignedActs>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Список неподписанных актов по ОСИ
 */

export function useGetApiOsiIdNotSignedActs<
  TData = Awaited<ReturnType<typeof getApiOsiIdNotSignedActs>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdNotSignedActs>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiIdNotSignedActsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Список подписанных актов по ОСИ
 */
export const getApiOsiIdSignedActs = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsDbActPrivateCoreLib>(
    { url: `/api/Osi/${id}/signed-acts`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiIdSignedActsQueryKey = (id: number) => {
  return [`/api/Osi/${id}/signed-acts`] as const;
};

export const getGetApiOsiIdSignedActsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiIdSignedActs>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdSignedActs>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiIdSignedActsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiIdSignedActs>>> = ({ signal }) =>
    getApiOsiIdSignedActs(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiIdSignedActs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiIdSignedActsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOsiIdSignedActs>>>;
export type GetApiOsiIdSignedActsQueryError = ErrorType<unknown>;

export function useGetApiOsiIdSignedActs<
  TData = Awaited<ReturnType<typeof getApiOsiIdSignedActs>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdSignedActs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdSignedActs>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdSignedActs>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdSignedActs<
  TData = Awaited<ReturnType<typeof getApiOsiIdSignedActs>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdSignedActs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdSignedActs>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdSignedActs>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdSignedActs<
  TData = Awaited<ReturnType<typeof getApiOsiIdSignedActs>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdSignedActs>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Список подписанных актов по ОСИ
 */

export function useGetApiOsiIdSignedActs<
  TData = Awaited<ReturnType<typeof getApiOsiIdSignedActs>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdSignedActs>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiIdSignedActsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить начальное сальдо по всем группам услуг для данного ОСИ
 */
export const getApiOsiIdSaldoByGroups = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsResponsesServiceGroupSaldoResponsePrivateCoreLib>(
    { url: `/api/Osi/${id}/saldo-by-groups`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiIdSaldoByGroupsQueryKey = (id: number) => {
  return [`/api/Osi/${id}/saldo-by-groups`] as const;
};

export const getGetApiOsiIdSaldoByGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiIdSaldoByGroups>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdSaldoByGroups>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiIdSaldoByGroupsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiIdSaldoByGroups>>> = ({ signal }) =>
    getApiOsiIdSaldoByGroups(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiIdSaldoByGroups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiIdSaldoByGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOsiIdSaldoByGroups>>>;
export type GetApiOsiIdSaldoByGroupsQueryError = ErrorType<unknown>;

export function useGetApiOsiIdSaldoByGroups<
  TData = Awaited<ReturnType<typeof getApiOsiIdSaldoByGroups>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdSaldoByGroups>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdSaldoByGroups>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdSaldoByGroups>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdSaldoByGroups<
  TData = Awaited<ReturnType<typeof getApiOsiIdSaldoByGroups>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdSaldoByGroups>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdSaldoByGroups>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdSaldoByGroups>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdSaldoByGroups<
  TData = Awaited<ReturnType<typeof getApiOsiIdSaldoByGroups>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdSaldoByGroups>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить начальное сальдо по всем группам услуг для данного ОСИ
 */

export function useGetApiOsiIdSaldoByGroups<
  TData = Awaited<ReturnType<typeof getApiOsiIdSaldoByGroups>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdSaldoByGroups>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiIdSaldoByGroupsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить долги прошлых периодов по данному ОСИ
 */
export const getApiOsiIdPastDebts = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsResponsesPastDebtsByOsiResponsePrivateCoreLib>(
    { url: `/api/Osi/${id}/past-debts`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiIdPastDebtsQueryKey = (id: number) => {
  return [`/api/Osi/${id}/past-debts`] as const;
};

export const getGetApiOsiIdPastDebtsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiIdPastDebts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdPastDebts>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiIdPastDebtsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiIdPastDebts>>> = ({ signal }) =>
    getApiOsiIdPastDebts(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiIdPastDebts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiIdPastDebtsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOsiIdPastDebts>>>;
export type GetApiOsiIdPastDebtsQueryError = ErrorType<unknown>;

export function useGetApiOsiIdPastDebts<
  TData = Awaited<ReturnType<typeof getApiOsiIdPastDebts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdPastDebts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdPastDebts>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdPastDebts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdPastDebts<
  TData = Awaited<ReturnType<typeof getApiOsiIdPastDebts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdPastDebts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdPastDebts>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdPastDebts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdPastDebts<
  TData = Awaited<ReturnType<typeof getApiOsiIdPastDebts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdPastDebts>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить долги прошлых периодов по данному ОСИ
 */

export function useGetApiOsiIdPastDebts<
  TData = Awaited<ReturnType<typeof getApiOsiIdPastDebts>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdPastDebts>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiIdPastDebtsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Выдает всевозможные группы и сервисы, которые когда-либо были на данном ОСИ, для создания корректировок
 */
export const getApiOsiIdGroupAndServicesForFixes = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseObjectSystemPrivateCoreLib>(
    { url: `/api/Osi/${id}/group-and-services-for-fixes`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiIdGroupAndServicesForFixesQueryKey = (id: number) => {
  return [`/api/Osi/${id}/group-and-services-for-fixes`] as const;
};

export const getGetApiOsiIdGroupAndServicesForFixesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiIdGroupAndServicesForFixes>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdGroupAndServicesForFixes>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiIdGroupAndServicesForFixesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiIdGroupAndServicesForFixes>>> = ({ signal }) =>
    getApiOsiIdGroupAndServicesForFixes(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiIdGroupAndServicesForFixes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiIdGroupAndServicesForFixesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiOsiIdGroupAndServicesForFixes>>
>;
export type GetApiOsiIdGroupAndServicesForFixesQueryError = ErrorType<unknown>;

export function useGetApiOsiIdGroupAndServicesForFixes<
  TData = Awaited<ReturnType<typeof getApiOsiIdGroupAndServicesForFixes>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdGroupAndServicesForFixes>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdGroupAndServicesForFixes>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdGroupAndServicesForFixes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdGroupAndServicesForFixes<
  TData = Awaited<ReturnType<typeof getApiOsiIdGroupAndServicesForFixes>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdGroupAndServicesForFixes>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdGroupAndServicesForFixes>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdGroupAndServicesForFixes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdGroupAndServicesForFixes<
  TData = Awaited<ReturnType<typeof getApiOsiIdGroupAndServicesForFixes>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdGroupAndServicesForFixes>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Выдает всевозможные группы и сервисы, которые когда-либо были на данном ОСИ, для создания корректировок
 */

export function useGetApiOsiIdGroupAndServicesForFixes<
  TData = Awaited<ReturnType<typeof getApiOsiIdGroupAndServicesForFixes>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdGroupAndServicesForFixes>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiIdGroupAndServicesForFixesQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Проверка на необходимость подписания новой оферты
 */
export const getApiOsiIdIsNeedSignNewOffer = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseBooleanSystemPrivateCoreLib>(
    { url: `/api/Osi/${id}/is-need-sign-new-offer`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiIdIsNeedSignNewOfferQueryKey = (id: number) => {
  return [`/api/Osi/${id}/is-need-sign-new-offer`] as const;
};

export const getGetApiOsiIdIsNeedSignNewOfferQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiIdIsNeedSignNewOffer>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdIsNeedSignNewOffer>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiIdIsNeedSignNewOfferQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiIdIsNeedSignNewOffer>>> = ({ signal }) =>
    getApiOsiIdIsNeedSignNewOffer(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiIdIsNeedSignNewOffer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiIdIsNeedSignNewOfferQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiOsiIdIsNeedSignNewOffer>>
>;
export type GetApiOsiIdIsNeedSignNewOfferQueryError = ErrorType<unknown>;

export function useGetApiOsiIdIsNeedSignNewOffer<
  TData = Awaited<ReturnType<typeof getApiOsiIdIsNeedSignNewOffer>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdIsNeedSignNewOffer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdIsNeedSignNewOffer>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdIsNeedSignNewOffer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdIsNeedSignNewOffer<
  TData = Awaited<ReturnType<typeof getApiOsiIdIsNeedSignNewOffer>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdIsNeedSignNewOffer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdIsNeedSignNewOffer>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdIsNeedSignNewOffer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdIsNeedSignNewOffer<
  TData = Awaited<ReturnType<typeof getApiOsiIdIsNeedSignNewOffer>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdIsNeedSignNewOffer>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Проверка на необходимость подписания новой оферты
 */

export function useGetApiOsiIdIsNeedSignNewOffer<
  TData = Awaited<ReturnType<typeof getApiOsiIdIsNeedSignNewOffer>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdIsNeedSignNewOffer>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiIdIsNeedSignNewOfferQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Добавить 1 месяц акции
 */
export const getApiOsiIdAddInPromo = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    { url: `/api/Osi/${id}/add-in-promo`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiIdAddInPromoQueryKey = (id: number) => {
  return [`/api/Osi/${id}/add-in-promo`] as const;
};

export const getGetApiOsiIdAddInPromoQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiIdAddInPromo>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAddInPromo>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiIdAddInPromoQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiIdAddInPromo>>> = ({ signal }) =>
    getApiOsiIdAddInPromo(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiIdAddInPromo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiIdAddInPromoQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOsiIdAddInPromo>>>;
export type GetApiOsiIdAddInPromoQueryError = ErrorType<unknown>;

export function useGetApiOsiIdAddInPromo<
  TData = Awaited<ReturnType<typeof getApiOsiIdAddInPromo>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAddInPromo>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdAddInPromo>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdAddInPromo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdAddInPromo<
  TData = Awaited<ReturnType<typeof getApiOsiIdAddInPromo>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAddInPromo>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdAddInPromo>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdAddInPromo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdAddInPromo<
  TData = Awaited<ReturnType<typeof getApiOsiIdAddInPromo>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAddInPromo>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Добавить 1 месяц акции
 */

export function useGetApiOsiIdAddInPromo<
  TData = Awaited<ReturnType<typeof getApiOsiIdAddInPromo>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdAddInPromo>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiIdAddInPromoQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Загрузить абонентов из эксель-файла
 */
export const postApiOsiIdLoadAbonentsFromExcel = (
  id: number,
  postApiOsiIdLoadAbonentsFromExcelBody: BodyType<string>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseList1OSICoreModelsDbAbonentPrivateCoreLib>(
    {
      url: `/api/Osi/${id}/load-abonents-from-excel`,
      method: 'POST',
      headers: { 'Content-Type': 'application/octet-stream' },
      data: postApiOsiIdLoadAbonentsFromExcelBody,
      signal
    },
    options
  );
};

export const getPostApiOsiIdLoadAbonentsFromExcelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiOsiIdLoadAbonentsFromExcel>>,
    TError,
    { id: number; data: BodyType<string> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiOsiIdLoadAbonentsFromExcel>>,
  TError,
  { id: number; data: BodyType<string> },
  TContext
> => {
  const mutationKey = ['postApiOsiIdLoadAbonentsFromExcel'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiOsiIdLoadAbonentsFromExcel>>,
    { id: number; data: BodyType<string> }
  > = (props) => {
    const { id, data } = props ?? {};

    return postApiOsiIdLoadAbonentsFromExcel(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiOsiIdLoadAbonentsFromExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiOsiIdLoadAbonentsFromExcel>>
>;
export type PostApiOsiIdLoadAbonentsFromExcelMutationBody = BodyType<string>;
export type PostApiOsiIdLoadAbonentsFromExcelMutationError = ErrorType<unknown>;

/**
 * @summary Загрузить абонентов из эксель-файла
 */
export const usePostApiOsiIdLoadAbonentsFromExcel = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiOsiIdLoadAbonentsFromExcel>>,
      TError,
      { id: number; data: BodyType<string> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiOsiIdLoadAbonentsFromExcel>>,
  TError,
  { id: number; data: BodyType<string> },
  TContext
> => {
  const mutationOptions = getPostApiOsiIdLoadAbonentsFromExcelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Переделать последние начисления ОСИ
 */
export const putApiOsiIdRemakeLastAccurals = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    { url: `/api/Osi/${id}/remake-last-accurals`, method: 'PUT' },
    options
  );
};

export const getPutApiOsiIdRemakeLastAccuralsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiOsiIdRemakeLastAccurals>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof putApiOsiIdRemakeLastAccurals>>, TError, { id: number }, TContext> => {
  const mutationKey = ['putApiOsiIdRemakeLastAccurals'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiOsiIdRemakeLastAccurals>>, { id: number }> = (
    props
  ) => {
    const { id } = props ?? {};

    return putApiOsiIdRemakeLastAccurals(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiOsiIdRemakeLastAccuralsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiOsiIdRemakeLastAccurals>>
>;

export type PutApiOsiIdRemakeLastAccuralsMutationError = ErrorType<unknown>;

/**
 * @summary Переделать последние начисления ОСИ
 */
export const usePutApiOsiIdRemakeLastAccurals = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiOsiIdRemakeLastAccurals>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof putApiOsiIdRemakeLastAccurals>>, TError, { id: number }, TContext> => {
  const mutationOptions = getPutApiOsiIdRemakeLastAccuralsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Получить доверенных пользователей ОСИ
 */
export const getApiOsiIdTrustedUsers = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsResponsesTrustedUserResponsePrivateCoreLib>(
    { url: `/api/Osi/${id}/trusted-users`, method: 'GET', signal },
    options
  );
};

export const getGetApiOsiIdTrustedUsersQueryKey = (id: number) => {
  return [`/api/Osi/${id}/trusted-users`] as const;
};

export const getGetApiOsiIdTrustedUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOsiIdTrustedUsers>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdTrustedUsers>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiOsiIdTrustedUsersQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOsiIdTrustedUsers>>> = ({ signal }) =>
    getApiOsiIdTrustedUsers(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOsiIdTrustedUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiOsiIdTrustedUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOsiIdTrustedUsers>>>;
export type GetApiOsiIdTrustedUsersQueryError = ErrorType<unknown>;

export function useGetApiOsiIdTrustedUsers<
  TData = Awaited<ReturnType<typeof getApiOsiIdTrustedUsers>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdTrustedUsers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdTrustedUsers>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdTrustedUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdTrustedUsers<
  TData = Awaited<ReturnType<typeof getApiOsiIdTrustedUsers>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdTrustedUsers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOsiIdTrustedUsers>>,
          TError,
          Awaited<ReturnType<typeof getApiOsiIdTrustedUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiOsiIdTrustedUsers<
  TData = Awaited<ReturnType<typeof getApiOsiIdTrustedUsers>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdTrustedUsers>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить доверенных пользователей ОСИ
 */

export function useGetApiOsiIdTrustedUsers<
  TData = Awaited<ReturnType<typeof getApiOsiIdTrustedUsers>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOsiIdTrustedUsers>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiOsiIdTrustedUsersQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Добавить доверенного пользователя к ОСИ
 */
export const postApiOsiIdTrustedUser = (
  id: number,
  requestsTrustedUserRequest: BodyType<RequestsTrustedUserRequest>,
  params?: PostApiOsiIdTrustedUserParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    {
      url: `/api/Osi/${id}/trusted-user`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestsTrustedUserRequest,
      params,
      signal
    },
    options
  );
};

export const getPostApiOsiIdTrustedUserMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiOsiIdTrustedUser>>,
    TError,
    { id: number; data: BodyType<RequestsTrustedUserRequest>; params?: PostApiOsiIdTrustedUserParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiOsiIdTrustedUser>>,
  TError,
  { id: number; data: BodyType<RequestsTrustedUserRequest>; params?: PostApiOsiIdTrustedUserParams },
  TContext
> => {
  const mutationKey = ['postApiOsiIdTrustedUser'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiOsiIdTrustedUser>>,
    { id: number; data: BodyType<RequestsTrustedUserRequest>; params?: PostApiOsiIdTrustedUserParams }
  > = (props) => {
    const { id, data, params } = props ?? {};

    return postApiOsiIdTrustedUser(id, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiOsiIdTrustedUserMutationResult = NonNullable<Awaited<ReturnType<typeof postApiOsiIdTrustedUser>>>;
export type PostApiOsiIdTrustedUserMutationBody = BodyType<RequestsTrustedUserRequest>;
export type PostApiOsiIdTrustedUserMutationError = ErrorType<unknown>;

/**
 * @summary Добавить доверенного пользователя к ОСИ
 */
export const usePostApiOsiIdTrustedUser = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiOsiIdTrustedUser>>,
      TError,
      { id: number; data: BodyType<RequestsTrustedUserRequest>; params?: PostApiOsiIdTrustedUserParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiOsiIdTrustedUser>>,
  TError,
  { id: number; data: BodyType<RequestsTrustedUserRequest>; params?: PostApiOsiIdTrustedUserParams },
  TContext
> => {
  const mutationOptions = getPostApiOsiIdTrustedUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Удалить доверенного пользователя у ОСИ
 */
export const deleteApiOsiIdTrustedUser = (
  id: number,
  params?: DeleteApiOsiIdTrustedUserParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    { url: `/api/Osi/${id}/trusted-user`, method: 'DELETE', params },
    options
  );
};

export const getDeleteApiOsiIdTrustedUserMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiOsiIdTrustedUser>>,
    TError,
    { id: number; params?: DeleteApiOsiIdTrustedUserParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiOsiIdTrustedUser>>,
  TError,
  { id: number; params?: DeleteApiOsiIdTrustedUserParams },
  TContext
> => {
  const mutationKey = ['deleteApiOsiIdTrustedUser'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiOsiIdTrustedUser>>,
    { id: number; params?: DeleteApiOsiIdTrustedUserParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return deleteApiOsiIdTrustedUser(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiOsiIdTrustedUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiOsiIdTrustedUser>>
>;

export type DeleteApiOsiIdTrustedUserMutationError = ErrorType<unknown>;

/**
 * @summary Удалить доверенного пользователя у ОСИ
 */
export const useDeleteApiOsiIdTrustedUser = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiOsiIdTrustedUser>>,
      TError,
      { id: number; params?: DeleteApiOsiIdTrustedUserParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiOsiIdTrustedUser>>,
  TError,
  { id: number; params?: DeleteApiOsiIdTrustedUserParams },
  TContext
> => {
  const mutationOptions = getDeleteApiOsiIdTrustedUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
